module.exports = __webpack_public_path__ + "static/media/architecture-blur-bridge-1769293.23da4786.jpg";